import React, { useState } from "react";
import { ScrollPanel } from "primereact/scrollpanel";
import { Button } from "primereact/button";
import { TreeNodeModel } from "../../models/category-new/category-tree-node";

const CategoryTopList = ({ categoriesLists, topCategorySelect }: any) => {
  const [activeCategories, setActiveCategories] = useState<string[]>([]);

  const handleCategorySelect = (category: TreeNodeModel) => {
    setActiveCategories((prevCategories) => {
      let updatedCategories: string[];
      
      if (prevCategories.includes(category.key)) {
        // Remove from selection if already selected
        updatedCategories = prevCategories.filter((key) => key !== category.key);
      } else {
        // Add to selection
        updatedCategories = [...prevCategories, category.key];
      }

      // Call parent with selected categories
      if (updatedCategories.length > 0) {
        const selectedCategoryObjects = categoriesLists.filter((cat: TreeNodeModel) =>
          updatedCategories.includes(cat.key)
        );
        // If only one category is selected, pass single object for backward compatibility
        // If multiple categories, pass the array
        if (selectedCategoryObjects.length === 1) {
          topCategorySelect(selectedCategoryObjects[0]);
        } else {
          topCategorySelect(selectedCategoryObjects);
        }
      } else {
        topCategorySelect(null);
      }

      return updatedCategories;
    });
  };

  const handleClearFilters = () => {
    setActiveCategories([]);
    topCategorySelect(null);
  };

  return (
    <>
      <div className="category-top-list-wrapper">
        <div className="category-filter-header">
          <div className="category-buttons-container">
            {categoriesLists && categoriesLists.length > 0 ? (
              categoriesLists.map((category: TreeNodeModel) => (
                <button
                  key={category.key}
                  className={`category-button ${
                    activeCategories.includes(category.key) ? "active" : ""
                  }`}
                  onClick={() => handleCategorySelect(category)}
                >
                  {category.icon && (
                    <span className={`category-icon pi ${category.icon}`}></span>
                  )}
                  <span className="category-label">{category.label}</span>
                </button>
              ))
            ) : null}
          </div>
          
          {/* Clear Filters Button - visible only when categories are selected */}
          {activeCategories.length > 0 && (
            <Button
              label="Clear Filters"
              icon="pi pi-times"
              className="p-button-sm p-button-text clear-filters-btn"
              onClick={handleClearFilters}
              tooltip="Clear all selected categories"
              tooltipOptions={{ position: "bottom" }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default CategoryTopList;
